import { Box } from '../../../components/Box.tsx'
import { Button, Paper, ToggleButton, ToggleButtonGroup, Typography } from '../../../components/generic.tsx'
import { I18n } from '../../../components/I18n.tsx'
import { Icon } from '../../../components/Icon.tsx'
import { ids } from '../../../ids.ts'
import type { MapSelectionMode } from './mapSelection.ts'

export const MapSelectionControls = ({
	mode,
	onModeChange,
	selectedCount,
	onClearAll,
}: {
	mode: MapSelectionMode
	onModeChange: (mode: MapSelectionMode) => void
	selectedCount: number
	onClearAll: () => void
}) => {
	return (
		<Box flex col gap={1} align='flex-start' sx={{ position: 'absolute', bottom: 0, left: 0, m: 1, zIndex: 1 }}>
			<Paper elevation={2} sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
				<Typography variant='body2' fontWeight='bold' px={1.5} whiteSpace='nowrap' data-ta={ids.reports.form.mapSelection.selectedCount}>
					<I18n i18nKey={($) => $.reports.form.mapSelection.selectedCount} count={selectedCount} />
				</Typography>
				<Button
					data-ta={ids.reports.form.mapSelection.clearAll}
					color='error'
					variant='contained'
					size='small'
					disabled={selectedCount === 0}
					onClick={onClearAll}
					sx={{ borderRadius: 0, boxShadow: 'none', whiteSpace: 'nowrap' }}
				>
					<I18n i18nKey={($) => $.reports.form.mapSelection.clearAll} />
				</Button>
			</Paper>
			<ToggleButtonGroup
				exclusive
				size='small'
				value={mode}
				onChange={(_, next: MapSelectionMode | null) => next && onModeChange(next)}
				sx={{ boxShadow: 2, bgcolor: 'background.paper' }}
			>
				<ToggleButton data-ta={ids.reports.form.mapSelection.clickMode} value='click' sx={modeButtonSx}>
					<Icon name='ArrowPointer' />
					<I18n i18nKey={($) => $.reports.form.mapSelection.clickToSelect} />
				</ToggleButton>
				<ToggleButton data-ta={ids.reports.form.mapSelection.dragMode} value='drag' sx={modeButtonSx}>
					<Icon name='VectorSquare' />
					<I18n i18nKey={($) => $.reports.form.mapSelection.dragToSelect} />
				</ToggleButton>
			</ToggleButtonGroup>
		</Box>
	)
}

const modeButtonSx = { gap: 1, whiteSpace: 'nowrap' }
